import { PopupMessageBox } from "../../../../common/messageBox";
import { GameData } from "../../gamestate/gameData";
import {
  displayBonusGameInfosWindow,
  toggleBonusGameMode,
  replaceAllWithBonus,
} from "../../inGameFunction";
import { convertCreditsFromServerToClient } from "../../../../common/datastructures/Credits";
// import { getParameterByName } from "../../common/getParameters";
import {
  updateBalance,
  setAllowedInputs,
} from "../../../../common/functions/Functions_General";
import { enablePlay } from "../../../../common/functions/Functions_GameBar";
import { Howl } from "howler";
import { replayMessageBox } from "./replayMessage";
import { updateEmulationWinBalance } from "../../../../common/gameLib/Replay/emulation/functionsEmulations";
import DeviceChecker from "../../../../common/functions/helper.ts/DeviceChecker";

export class BonusSpinMessageWindow {
  private parent: PIXI.Container;

  private messagetoDisplay: number;
  private bonusGameEndMessage: PopupMessageBox;
  private size: Array<number>;
  private activeGameData: GameData;
  private bonusGameEnd_Music: Howl;
  private ReloadMessageBox: replayMessageBox;
  private sergioPicture: PIXI.Sprite;
  private newMessageFrameBG: PIXI.Sprite;
  private bgSergio: PIXI.Sprite;

  private bgTween: PIXI.tween.Tween;
  private bgTween2: PIXI.tween.Tween;
  private newMessageFrame: PIXI.Sprite;

  constructor(
    parent: PIXI.Container,
    size: Array<number>,
    activeGameData: GameData
  ) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    this.messagetoDisplay = 1;
    this.bonusGameEndMessage;

    this.size = size;
    this.activeGameData = activeGameData;
    this.setup(parent);

    this.newMessageFrameBG = new PIXI.Sprite(
      PIXI.Texture.fromFrame("bg_sergioMessage.png")
    ); //
    this.newMessageFrameBG.blendMode = PIXI.BLEND_MODES.ADD;
    // this.messageBoxNewDesign.scale.set(1,1.4);
    this.newMessageFrameBG.anchor.set(0.5);
    this.newMessageFrameBG.y =
      this.bonusGameEndMessage.getFrame().height / 2 - 30; //this.messageBoxNewDesign.height;
    this.newMessageFrameBG.x = 850; //this.bonusGameEndMessage.getFrame().width/2//this.messageBoxNewDesign.width/2;
    this.bonusGameEndMessage.getFramenull().addChild(this.newMessageFrameBG);

    this.bgSergio = new PIXI.Sprite(
      PIXI.Texture.fromFrame("bg_sergioMessage.png")
    ); //
    this.bgSergio.blendMode = PIXI.BLEND_MODES.ADD;
    // this.messageBoxNewDesign.scale.set(1,1.4);
    this.bgSergio.anchor.set(0.5);
    this.bgSergio.scale.set(1.2);
    this.bgSergio.y = this.bonusGameEndMessage.getFrame().height / 2 - 30;
    this.bgSergio.x = 850; //this.messageBoxNewDesign.width/2;
    this.bonusGameEndMessage.getFramenull().addChild(this.bgSergio);

    this.newMessageFrame = new PIXI.Sprite(
      PIXI.Texture.fromFrame("messageFrame.png")
    ); //
    // this.messageBoxNewDesign.scale.set(1,1.4);
    this.newMessageFrame.anchor.set(0.5);
    this.newMessageFrame.y =
      this.bonusGameEndMessage.getFrame().height / 2 - 30; //this.messageBoxNewDesign.height;
    this.newMessageFrame.x = this.bonusGameEndMessage.getFrame().width / 2; //this.messageBoxNewDesign.width/2;

    this.bonusGameEndMessage.getFramenull().addChild(this.newMessageFrame);
    this.bonusGameEndMessage.setAlphaDefaultFrame(0);

    this.ReloadMessageBox = new replayMessageBox(parent, size, activeGameData);
    this.sergioPicture = new PIXI.Sprite(
      PIXI.Texture.fromFrame("sergioOverlayCut.png")
    );
    this.sergioPicture.scale.set(1.2);
    this.sergioPicture.y = 90;
    this.sergioPicture.x = 800;
    this.sergioPicture.anchor.set(0.5);
    this.bonusGameEndMessage.getFramenull().addChild(this.sergioPicture);

    this.bgTween = PIXI.tweenManager.createTween(this.newMessageFrameBG);
    this.bgTween
      .from({ rotation: 0 }) //, scale: { x: 0.5, y: 0.5 }, alpha: 1 })
      .to({ rotation: Math.PI * 2 }); //, scale: { x: 2, y: 2 }, alpha: 0 });
    this.bgTween.time = 10000; //get speed from winline animation
    this.bgTween.easing = PIXI.tween.Easing.linear();
    this.bgTween.loop = true;
    this.bgTween.stop();

    this.bgTween2 = PIXI.tweenManager.createTween(this.bgSergio);
    this.bgTween2
      .from({ rotation: 0 }) //, scale: { x: 0.5, y: 0.5 }, alpha: 1 })
      .to({ rotation: Math.PI * -2 }); //, scale: { x: 2, y: 2 }, alpha: 0 });
    this.bgTween2.time = 10000; //get speed from winline animation
    this.bgTween2.easing = PIXI.tween.Easing.linear();
    this.bgTween2.loop = true;
    this.bgTween2.stop();
  }

  public getReloadMessageBoxOpen = (): Function => {
    return this.ReloadMessageBox.getDisplayMessageIn;
  };

  public getReloadMessageBox = (): replayMessageBox => {
    return this.ReloadMessageBox;
  };

  private setup = (_parent: PIXI.Container): void => {
    this.parent.alpha = 0;
    // this.inTween.pingpong=true;

    this.bonusGameEndMessage = new PopupMessageBox(
      1,
      this.size,
      this.activeGameData
    );
    this.bonusGameEndMessage.setHeadText(
      this.activeGameData.gameTextGeneral.congrats
    );
    this.bonusGameEndMessage.setBodyText("!");
    // this.bonusGameEndMessage.setChildOf(this.parent);
    this.bonusGameEndMessage.setLabel(
      0,
      this.activeGameData.gameTextGeneral.continue
    );
    this.bonusGameEndMessage.setButtons(0, this.close.bind(this));
    // this.close()  ;
    this.bonusGameEndMessage.setMessageBoxPosY(380);

    this.bonusGameEnd_Music = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/12972918_jackpot.m4a?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 1,
      // loop:true,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        win: [8700, 5029, false],
      },
    });
    this.activeGameData.bonusMusicList.push(this.bonusGameEnd_Music);
  };

  public close = (): void => {
    this.bgTween.stop();
    this.bgTween2.stop();
    // this.activeGameData.sergioWinAnimation.setVisible(false);
    this.activeGameData.mainGame.setWinlineHidden();

    this.activeGameData.newSergioWinANimation.stop();

    this.activeGameData.freeSpinMode.setMessageDisplay();
    this.parent.alpha = 0;

    this.bonusGameEndMessage.setMessageBoxVisibile(false);

    this.activeGameData.resetAllBtns(this.activeGameData);

    if (this.activeGameData.betResponse.jackpotContext == undefined) {
      enablePlay(true, this.activeGameData);
      setAllowedInputs(this.activeGameData);
    }
    this.activeGameData.isBonusMessageVisible = false;

    if (this.messagetoDisplay == 1) {
      // let test=this.activeGameData.GameContext().usedInputAction==this.activeGameData.API_handler.getSe();
      // console.log((this.activeGameData.betResponse.gameContext.contextData).usedInputAction, this.activeGameData.API_handler.getServerActionBonusSpin())
      if (this.activeGameData.GameContext().gameRoundBalance.bonusSpins == 0) {
        updateBalance(this.activeGameData);
      }

      displayBonusGameInfosWindow(false, this.activeGameData);
      //update emulation balance if game round is ended
      updateEmulationWinBalance(this.activeGameData);
    }

    if (this.messagetoDisplay == 2) {
      replaceAllWithBonus(this.activeGameData, true);

      this.activeGameData.bonusGameMode = true;
      this.activeGameData.bonusGameModeStarted = true;
    } else {
      this.activeGameData.bonusGameMode = false;
      this.activeGameData.bonusGameModeStarted = false;
      replaceAllWithBonus(this.activeGameData, false);
      // console.log("EXIT BONUS GAME")
      this.activeGameData.mainGame.setBonusLeftVisible(false);
      this.activeGameData.environment.isNight(false); //exit bonus game
    }

    toggleBonusGameMode(this.activeGameData);

    if (this.activeGameData.GameContext().bonus)
      this.activeGameData.mainGame.setWinlineHidden();
    setAllowedInputs(this.activeGameData);
    if (
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.replayMode
    ) {
      // console.log("increment2")
      this.activeGameData.replay.incrementIndex();
      // console.log("INCREASEssssssss")
    }
    this.activeGameData.environment.checkBonusMusic();
  };
  public setRecoveryText = (): void => {
    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.gameRecovered + "sdsdsd"
    );
    this.bonusGameEndMessage.setHeadText(" ");
    this.sergioPicture.alpha = 0;
    this.newMessageFrame.alpha = 0;
    this.newMessageFrameBG.alpha = 0;
    this.bgTween.stop();
    this.bgTween2.stop();
    this.bonusGameEndMessage.setAlphaDefaultFrame(1);
    //----
  };

  public setNewText = (head: string, body: string): void => {
    this.bonusGameEndMessage.setHeadText(head);
    this.bonusGameEndMessage.setBodyText(body);
    this.sergioPicture.alpha = 0;
  };

  private displayMessageIn = (): void => {
    this.activeGameData.playable = false;
    // if (this.messagetoDisplay === 1) {

    enablePlay(false, this.activeGameData);
    this.activeGameData.isBonusMessageVisible = true;
    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.msgFS3 +
        " " +
        this.activeGameData.GameContext().gameRoundBalance.bonusSpins +
        " " +
        this.activeGameData.gameText.firespins +
        "!"
    );
    this.parent.alpha = 1;
    this.bonusGameEndMessage.setMessageBoxVisibile(true, 0); //make it interactive
    this.messagetoDisplay = 2;
    // }
    // else
    // {
    // 	enablePlay(true,this.activeGameData)
    // 	this.activeGameData.isBonusMessageVisible=false
    // };
    // this.activeGameData.environment.checkBonusMusic();
    // this.chechBonusMusic()
    this.activeGameData.mainGame.setBonusLeft(
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins
    );
    // console.log("ssdsda")

    this.sergioPicture.alpha = 1;
    this.newMessageFrame.alpha = 1;
    this.newMessageFrameBG.alpha = 1;
    this.bgTween.start();
    this.bgTween2.start();
    this.bonusGameEndMessage.setAlphaDefaultFrame(0);
  };
  public getDisplayMessageIn = (): Function => {
    // console.log("MESSAGE BOX TO DISPLAY")
    return this.displayMessageIn;
  };

  public displayMessageOut = (): void => {
    this.bonusGameEndMessage.setAlphaDefaultFrame(0);
    this.sergioPicture.alpha = 1;
    this.newMessageFrame.alpha = 1;
    this.newMessageFrameBG.alpha = 1;
    this.bgTween.start();
    this.bgTween2.start();
    // console.log("openEXIT")
    this.activeGameData.disableAllBtns(this.activeGameData);
    enablePlay(false, this.activeGameData);
    this.activeGameData.isBonusMessageVisible = true;

    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.totalWin + " :"
    );
    this.bonusGameEndMessage.setBodyText2(
      convertCreditsFromServerToClient(
        this.activeGameData.GameContext().gameRoundBalance.credits.amount
      ).toFixed(2) +
        "  " +
        this.activeGameData.currency +
        " !"
    );

    this.parent.alpha = 1;
    this.bonusGameEndMessage.setMessageBoxVisibile(true, 1);
    this.messagetoDisplay = 1;
    this.activeGameData.jumpCoin.startJump();
    this.bonusGameEnd_Music.play("win");

    // this.activeGameData.environment.checkBonusMusic();
    // this.chechBonusMusic()
    this.activeGameData.replay.replayCollectWinCheck();
  };

  // }

  public getAlpha() {
    // let i = this.parent.alpha ? true : false;
    return this.parent.alpha;
  }
}
